import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteTripStep(input: { id: number; tripBookingId: number }) {
  const { id, tripBookingId } = input
  return restApiClient
    .url(
      constructApiUrl(API['trip-bookings'].deleteTripStep.url, {
        id: tripBookingId,
        tripStepId: id
      })
    )
    .delete()
}
